export default __webpack_public_path__ + "static/media/bmm-alarm.4401bda0.jpeg";